import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch } from 'app/config/store';
import { deleteDashboard } from './dashboard.reducer';
import { toast } from 'react-toastify';

export interface DashboardDeleteDialogProps {
  toggleDeleteModal: () => void;
  dashboard: { id: number; name: string };
  history?: any;
  redirectUrl?: string;
}

const DashboardDeleteDialog = ({ toggleDeleteModal, dashboard, history, redirectUrl }: DashboardDeleteDialogProps) => {
  const dispatch = useAppDispatch();

  const confirmDelete = () => {
    dispatch(deleteDashboard(dashboard.id)).then((resp: any) => {
      if (resp?.payload) {
        toast.success('Dashboard deleted successfully');
      } else {
        toast.error(resp?.error?.message || 'Error deleting dashboard');
      }
    });
    toggleDeleteModal();
    if (history && redirectUrl) {
      history.push(redirectUrl);
    }
  };

  return (
    <Modal isOpen toggle={toggleDeleteModal}>
      <ModalHeader toggle={toggleDeleteModal}>Confirm Delete</ModalHeader>
      <ModalBody>
        Are you sure you want to delete <strong>{dashboard.name}</strong>?
      </ModalBody>
      <ModalFooter>
        <Button id="cancel-save" data-cy="entityCreateCancelButton" onClick={toggleDeleteModal} replace color="info">
          <span className="d-none d-md-inline">Cancel &nbsp;</span>
        </Button>
        <Button color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" /> Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DashboardDeleteDialog;
